const typeEnum = {
  C: 'Call',
  P: 'Put',
};

export function returnOptionType(symbol) {
  let optionDetails;
  const regex = /\d/;
  for (let i = 0; i < symbol.length; i++) {
    if (regex.test(symbol[i])) {
      optionDetails = symbol.slice(i);
      break;
    }
  }
  let strikeDetails;
  for (let i = 0; i < optionDetails.length; i++) {
    if (!regex.test(optionDetails[i])) {
      strikeDetails = optionDetails.slice(i);
      break;
    }
  }
  const callOrPutt = strikeDetails[0];
  return typeEnum[callOrPutt];
}
